import { allSupportedExtensions } from "store/features/resizeDownload/types/resizeTypes";

export const extensionsConfig = {
    "bulk-resize": allSupportedExtensions,
    "color-picker": allSupportedExtensions,
    "image-compressor": ["jpg", "jpeg", "png", "gif"],
    "compress-jpeg": ["jpg", "jpeg"],
    "png-compressor": ["png"],
    "gif-compressor": ["gif"],
    resizer: allSupportedExtensions,
    "resize-png": ["png"],
    "resize-jpg": ["jpg", "jpeg"],
    "resize-webp": ["webp", "image/webp"], // image/webp if for google drive
    flip: allSupportedExtensions,
    rotate: allSupportedExtensions,
    crop: allSupportedExtensions,
    enlarge: allSupportedExtensions,
    "meme-generator": allSupportedExtensions,
    "crop-image": allSupportedExtensions,
    "crop-png": ["png"],
    "crop-webp": ["webp", "image/webp"],
    "crop-jpg": ["jpg", "jpeg"],
};
